/* Aeshal — cart UX helpers (audit fixes, 2026-07-10)
 * 1) Header cart count bubble, kept in sync via Pipeline's cart events.
 * 2) After a successful add-to-cart, open the cart drawer; if the drawer
 *    isn't usable, show an "Added to your bag" toast instead.
 * 3) Clamp quantity steppers to the input's max attribute — Pipeline's
 *    stepper ignores it, letting shoppers exceed 1-of-1 stock.
 */
(function () {
  var lastAtc = 0;

  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('[data-add-to-cart]')) {
      lastAtc = Date.now();
    }
  }, true);

  /* --- 3: quantity clamp ------------------------------------- */
  function clampQty(input) {
    if (!input || !input.matches || !input.matches('[data-quantity-input]')) return;
    var max = parseInt(input.max, 10);
    var val = parseInt(input.value, 10);
    if (!isNaN(max) && max > 0 && !isNaN(val) && val > max) {
      input.value = max;
    }
  }

  document.addEventListener('change', function (e) { clampQty(e.target); }, true);
  document.addEventListener('input', function (e) { clampQty(e.target); }, true);
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('[data-increase-quantity]');
    if (!btn) return;
    var wrap = btn.closest('[data-quantity-selector]');
    var input = wrap && wrap.querySelector('[data-quantity-input]');
    if (!input) return;
    setTimeout(function () {
      clampQty(input);
    }, 0);
  });

  /* --- 1: count bubble --------------------------------------- */
  function bubbles(count) {
    document.querySelectorAll('[data-drawer-toggle="drawer-cart"]').forEach(function (link) {
      /* Only the header cart icons get a count badge — skip cart toggles that
         live inside the drawer itself (e.g. the drawer's close button). */
      if (link.closest('[data-drawer]')) return;

      /* Anchor the badge to the bag ICON via a wrapper span so it hugs the
         icon's corner on both the desktop and mobile headers, and stays inside
         the desktop link box (.navlink--cart has overflow:hidden, which would
         otherwise clip a link-anchored badge into a stray black sliver). */
      var icon = link.querySelector('svg');
      var wrap = null;
      if (icon) {
        wrap = link.querySelector('.aes-cart-icon-wrap');
        if (!wrap) {
          wrap = document.createElement('span');
          wrap.className = 'aes-cart-icon-wrap';
          icon.parentNode.insertBefore(wrap, icon);
          wrap.appendChild(icon);
        }
      }
      var host = wrap || link;

      /* Dedupe: remove any badge left outside the wrapper (e.g. from an
         earlier build that appended it straight onto the link). */
      link.querySelectorAll('.aes-cart-count').forEach(function (old) {
        if (old.parentNode !== host) old.remove();
      });

      var b = host.querySelector('.aes-cart-count');
      if (!b) {
        b = document.createElement('span');
        b.className = 'aes-cart-count';
        b.setAttribute('aria-hidden', 'true');
        host.appendChild(b);
      }
      b.textContent = count > 99 ? '99+' : String(count);
      b.classList.toggle('is-empty', !count);
    });
  }

  function seedFromDom() {
    var el = document.querySelector('[data-header-cart-count]');
    var n = el ? parseInt(el.getAttribute('data-header-cart-count'), 10) : 0;
    bubbles(isNaN(n) ? 0 : n);
  }

  /* --- 2: post-add feedback ----------------------------------- */
  function drawerVisible() {
    var d = document.querySelector('[data-drawer="drawer-cart"]');
    if (!d) return false;
    var r = d.getBoundingClientRect();
    var cs = window.getComputedStyle(d);
    return cs.visibility !== 'hidden' && r.width > 0 && r.width < window.innerWidth * 0.9 && r.height > 200 && r.top < window.innerHeight * 0.5;
  }

  function toast() {
    var t = document.querySelector('.aes-add-toast');
    if (!t) {
      t = document.createElement('div');
      t.className = 'aes-add-toast';
      t.innerHTML = 'Added to your bag <a href="/cart">View bag</a>';
      document.body.appendChild(t);
    }
    requestAnimationFrame(function () { t.classList.add('is-visible'); });
    clearTimeout(t._aesTimer);
    t._aesTimer = setTimeout(function () { t.classList.remove('is-visible'); }, 4500);
  }

  function onCart(e) {
    var cart = e.detail && e.detail.cart;
    if (cart && typeof cart.item_count !== 'undefined') bubbles(cart.item_count);
    else seedFromDom();

    if (e.type === 'theme:cart:change' && lastAtc && Date.now() - lastAtc < 5000) {
      lastAtc = 0;
      /* FIX (Grok, 2026-10-31): defer opening the drawer to the next tick.
         This listener is registered before Pipeline's CartItems listener, so
         clicking the toggle synchronously opened the drawer while CartItems
         still held the pre-add cart (item_count 0) -> it rendered "Your cart
         is empty" and never refreshed. Waiting one tick lets every
         theme:cart:change listener receive the new cart first. */
      setTimeout(function () {
        if (drawerVisible()) return;
        var toggle = document.querySelector('[data-drawer-toggle="drawer-cart"]');
        if (toggle) toggle.click();
        setTimeout(function () { if (!drawerVisible()) toast(); }, 450);
      }, 0);
    }
  }

  document.addEventListener('theme:cart:init', onCart);
  document.addEventListener('theme:cart:change', onCart);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', seedFromDom);
  } else {
    seedFromDom();
  }
})();
